// Gate SÍNCRONO da "carga ativa" do doLoad (perf/tv-live-zap-failover).
//
// PROBLEMA (achado no device board): num burst de zaps em tela cheia
// (7×CH+/- @~280ms), cada zap navega e dispara um `doLoad`. O guard de corrida
// que decidia "esta carga ainda é a atual? (senão aborta antes de player.load())"
// lia `stateRef.current.channelId` — mas esse ref só é atualizado por um
// `useEffect` PÓS-COMMIT do React, com LAG. Enquanto o stateRef não alcançava o
// canal do zap mais novo, a carga intermediária (já superada) PASSAVA o guard e
// chamava `player.load()` assim mesmo → abria sign + GET do stream do canal que
// o usuário já deixou pra trás.
//
// Nas TVs-alvo o pool de conexões do WebView é minúsculo (Chr38/53) e o painel
// Xtream costuma limitar 1 conexão por usuário: com N GETs de stream em voo, eles
// SERIALIZAM (cada canal só abre quando o anterior solta a conexão) → o settle do
// burst vira ~N×TTFF (medido ~15,6s pra 7 zaps). O debouncer leading-edge
// (`zap-debounce.ts`) não cobre isso de propósito: 280ms > janela de 180ms, então
// taps deliberados avançam canal a canal (comportamento desejado pra navegação).
//
// FIX: um token trocado no corpo SÍNCRONO de cada `doLoad` (mesma volta do event
// loop do zap). Um `doLoad` novo invalida o anterior NA HORA, então a carga
// intermediária detecta no 1º checkpoint assíncrono (após o sign, ANTES de
// `player.load()`) que foi superada e aborta — sem abrir o GET do stream. Só a
// ÚLTIMA carga do burst (e, quando o sign é rápido o bastante, a leading) chega a
// `player.load()`. Settle limitado a ~2×TTFF, não N×.
//
// Zap isolado é intocado: sem zap seguinte, o token continua ativo quando o sign
// resolve → carrega na hora (nada de latência artificial de trailing-debounce).

export interface LoadGate {
  /**
   * Chamar no corpo SÍNCRONO de cada `doLoad`. Invalida a carga anterior e
   * devolve o token DESTA carga. Síncrono de propósito: precisa ganhar do lag
   * do `stateRef` pós-commit.
   */
  begin: () => symbol
  /**
   * Chamar em cada checkpoint assíncrono (após um `await`). `false` = esta carga
   * foi superada por um `begin()` posterior (zap novo) → abortar ANTES de
   * `player.load()`.
   */
  isActive: (token: symbol) => boolean
}

export function createLoadGate(): LoadGate {
  let active: symbol | null = null
  return {
    begin() {
      const token = Symbol('live-load')
      active = token
      return token
    },
    isActive(token) {
      return active === token
    },
  }
}
